// This file contains the default text used by form elements.

export const DEFAULT_TITLE = 'Untitled';
export const DEFAULT_INSTRUCTIONS = '<p>Enter form instructions</p>';
export const DEFAULT_QUESTION_TEXT = '<p>Enter question text</p>';
export const DEFAULT_IMAGE_TEXT = 'Enter image caption';
export const DEFAULT_SECTION_TEXT = '<p>Enter section instructions</p>';
